import './bootstrap.js';

// External Dependencies
import Vue from 'vue';

// Internal Dependencies
import store from './store';
import router from './routes';
import App from './App.vue';
import addRouterHooks from './routes/router-hooks';
import { refreshOnError } from './helpers/refresh';

import VueVirtualScroller from 'vue-virtual-scroller';
import '~vue-virtual-scroller/dist/vue-virtual-scroller.css';

Vue.use(VueVirtualScroller);

// Enable devtools in development builds
if ( import.meta.env.MODE === 'development' ) {
    Vue.config.devtools = true;
}

const app = new Vue({
    store,
    router,
    data() {
        return {
            environment: import.meta.env.VITE_APP_ENV
        }
    },
    components: {
        App
    }
});

addRouterHooks(router, store, 'app');

router.onReady(() => {
    app.$mount('#app');
});

refreshOnError(app);
